const CODE_LENGTH = 12;

export function compactVerificationCode(value: string): string {
  return value.toUpperCase().replace(/[^23456789ABCDEFGHJKLMNPQRSTUVWXYZ]/g, "").slice(0, CODE_LENGTH);
}

export function formatVerificationCode(value: string): string {
  return compactVerificationCode(value).match(/.{1,4}/g)?.join("-") ?? "";
}

export function isCompleteVerificationCode(value: string): boolean {
  return compactVerificationCode(value).length === CODE_LENGTH;
}
